import { Outlet, Link, useLocation } from 'react-router-dom';

const menuItems = [
  {
    label: 'General Settings',
    href: '/org/settings',
    key: 'jhjyreuhcuhctwvxyf',
  },
  {
    label: 'Records Management',
    href: '/org/settings/records',
    key: 'jhjyreoeythfbcwvxyf',
  },
  {
    label: 'Users Management',
    href: '/org/settings/users',
    key: 'jhjyhsdbhyehctwvxyf',
  },
  {
    label: 'Roles Management',
    href: '/org/settings/roles',
    key: 'jhgyeghbjshuyydhncui',
  },
  {
    label: 'Subscription',
    href: '/org/settings/subscription',
    key: 'sjbufsiuefhiuhfuyekw',
  },
  // {
  //   label: 'Security',
  //   href: '/org/settings/security',
  //   key: 'lsoiwinvownxjkjdnvnp',
  // },
];

const OrgSettings = () => {
  const location = useLocation();

  // Check if current path matches menu item path or if it's a subpath
  const isActive = (href) => {
    if (href === '/org/settings') {
      return location.pathname === '/org/settings';
    }
    return location.pathname.startsWith(href);
  };

  return (
    <div className=" p-5">
      <div className="md:flex grid grid-cols-1 gap-y-1 md:flex-row gap-x-6 border-b-[1.5px] border-b-[#c8ccd39e] text-[#979EAC] mb-4 font-medium md:w-4/5 w-full text-sm">
        {menuItems.map((item) => {
          const currentUrl = isActive(item.href);
          return (
            <Link
              to={item.href}
              key={item.key}
              className={`${
                currentUrl
                  ? 'text-purple-600 md:border-b-purple-600 md:border-b-2'
                  : 'pb-1'
              } `}
            >
              <p>{item.label}</p>
            </Link>
          );
        })}
      </div>
      <Outlet />
    </div>
  );
};

export default OrgSettings;
